import { ReportController } from '@/controllers/Report';
import { Sentry } from '@/services/Sentry';
import { RootDispatch } from '@/store';

async function fetchReport(this: RootDispatch, page: number | null): Promise<void> {
  try {
    const { data } = await ReportController.fetchReport(page);

    this.reports.setReport(data);
  } catch (e) {
    Sentry.captureError(e as Error);
  }
}

export const reportEffects = (dispatch: RootDispatch) => ({
  fetchReport: fetchReport.bind(dispatch),
});
